import * as THREE from 'three';
import { TweenMax, Power2 } from 'gsap';

export default function canvas() {
  let camera, scene, renderer;
  let timer = 0;
  let particles = [];
  let elem = document.getElementById('glCanvas')
  init();

  function init() {
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.z = 10;
    camera.position.y = -15;

    renderer = new THREE.WebGLRenderer({ antialias: true, alpha:true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    elem.appendChild(renderer.domElement);

    // パーティクルを生成する関数
    function createParticle() {
      const geometry = new THREE.CircleGeometry(0.1, 3); // 粒子の形状を指定
      const material = new THREE.MeshBasicMaterial({ color: Math.random() * 0xffffff }); // ランダムな色を設定
      const particle = new THREE.Mesh(geometry, material);
      particle.velocity = new THREE.Vector3((Math.random() - 0.5) * 0.1, (Math.random() - 0.5) * 0.1, (Math.random() - 0.5) * 0.001);
      scene.add(particle);
      particles.push(particle);
    }

    // 初期状態で100個の粒子を生成
    for (let i = 0; i < 512; i++) {
      createParticle();
    }
    elem.classList.add('active');
    window.addEventListener('resize', onWindowResize);
    document.addEventListener('mousemove', moveImage);
    animate();
  }

  function animate() {
    // パーティクルの移動
    timer += .1
    let $i = 0;
    particles.forEach((particle) => {
      $i++ ;

      particle.rotation.z = Math.sin($i) + timer
      particle.position.add(particle.velocity);
      // 画面外に出たら再び画面内に戻す
      if (particle.position.x < -15 || particle.position.x > 15 ||
        particle.position.y < -30 || particle.position.y > 0 ||
        particle.position.z < -10 || particle.position.z > 15) {
          particle.position.set(0, 0, 0);
          particle.velocity = new THREE.Vector3((Math.random() - 0.5) * 0.1, (Math.random() - 0.5) * 0.1, (Math.random() - 0.5) * 0.01);
        }
      });
      
    renderer.render(scene, camera);
    requestAnimationFrame(animate);
  }
  
  function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
  }
  
  function getMousePosition(event) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  
  function moveImage(event) {
    const mousePosition = getMousePosition(event);
    const image = document.getElementById('moving-image');
    const imageCenterX = image.offsetLeft + image.offsetWidth / 2;
    const imageCenterY = image.offsetTop + image.offsetHeight / 2;
    const deltaX = mousePosition.x - imageCenterX;
    const deltaY = mousePosition.y - imageCenterY;
    TweenMax.to(image, 2.0, {
      x: deltaX * -.05, // X方向の移動量
      y: deltaY * -.05, // Y方向の移動量
      ease: Power2.easeOut // アニメーションのイージング
    });
  }
}
